export default {
  // plays nicer with mocks
  createFileOnSignup: () =>
    process.env.NEXT_PUBLIC_CREATE_FILE_ON_SIGNUP === 'true',
  mobileSignupRedirect: () =>
    process.env.NEXT_PUBLIC_MOBILE_SIGNUP_REDIRECT === 'true',
  userLikes: () => process.env.NEXT_PUBLIC_USER_LIKES === 'true',
  communitySearch: () => process.env.NEXT_PUBLIC_COMMUNITY_SEARCH === 'true',
  showSeatUse: () => process.env.NEXT_PUBLIC_SHOW_SEAT_USE === 'true',
  showRivOnHover: () => process.env.NEXT_PUBLIC_SHOW_RIV_ON_HOVER === 'true',
  fullscreenMode: () => process.env.NEXT_PUBLIC_FULLSCREEN_MODE === 'true',
  showRetiredStudioInfo: () =>
    process.env.NEXT_PUBLIC_SHOW_RETIRED_STUDIO_INFO === 'true',
  passwordComplexity: () =>
    process.env.NEXT_PUBLIC_PASSWORD_COMPLEXITY === 'true',
  suppressOpenInRive: () =>
    process.env.NEXT_PUBLIC_SUPPRESS_OPEN_IN_RIVE === 'true',
  getCommunityPath: () =>
    process.env.NEXT_PUBLIC_COMMUNITY_PATH ?? 'https://community.rive.app/',
  useLevaEmbedUrlView: () => process.env.NEXT_PUBLIC_LEVA === 'true',
  dataBinding: () => process.env.NEXT_PUBLIC_DATA_BINDING === 'true',
  apiClientCredentials: () =>
    process.env.NEXT_PUBLIC_ENABLE_API_CLIENT_CREDENTIALS === 'true',
  downloadCommunityShot: () =>
    process.env.NEXT_PUBLIC_DOWNLOAD_COMMUNITY_SHOT === 'true',
  cadet: () => process.env.NEXT_PUBLIC_CADET_PRICING === 'true',
  showProjectMembership: () =>
    process.env.NEXT_PUBLIC_SHOW_PROJECT_MEMBERSHIP === 'true',
  billingDetails: () => process.env.NEXT_PUBLIC_BILLING_DETAILS === 'true',
  teamProviderKeys: () =>
    process.env.NEXT_PUBLIC_ENABLE_TEAM_PROVIDER_KEYS === 'true',
  appleSignin: () => process.env.NEXT_PUBLIC_APPLE_SIGNIN === 'true',
  hostedPages: () => process.env.NEXT_PUBLIC_ENABLE_HOSTED_PAGES === 'true',
  pagesAnalytics: () =>
    process.env.NEXT_PUBLIC_ENABLE_PAGES_ANALYTICS === 'true',
  newAccountsPage: () => process.env.NEXT_PUBLIC_NEW_ACCOUNTS_PAGE === 'true',
};
